export default __webpack_public_path__ + "static/media/roomTwo.48c60181.jpeg";